import { Divider } from "@mui/material";
import { Image } from "components/CdBalance/style";
import { LargeButton, Ptag } from "components/core";
import { FlexColumn } from "components/core/Cards/styles";
import routes from "components/routes";
import { insurers } from "constants/businessConstant";
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { colors } from "theme";
import { formatToRupees } from "utlis/utils";

function BufferCard({ details }) {
  const [insurer, setInsurer] = useState();
  const navigate = useNavigate();
  const initialValues = useMemo(() => {
    const product_dtails = JSON.parse(localStorage.getItem("gmc_details"));
    let boolean_value =
      Object.keys(product_dtails).includes("health_insurance");
    if (boolean_value) {
      let logo = product_dtails["health_insurance"]?.service_provider_logo;
      setInsurer(logo);
    }
  }, [details]);
  const redirectToUpdatePage = () => {
    navigate(`/${routes.UPDATE_CORPORATE_BUFFER}`);
  };
  return (
    <>
      <Box>
        <FlexRow style={{ justifyContent: "space-between" }}>
          <FlexColumn style={{ gap: "0.5rem" }}>
            <Ptag fontWeight="500" fontSize="20px">
              Group Mediclaim Cover
            </Ptag>
            <Ptag fontWeight="500" fontSize="14px">
              last updated on {details?.last_updated_date}
            </Ptag>
          </FlexColumn>
          <Image src={insurer} style={{ marginTop: "0", maxWidth: '7rem', maxHeight: '3rem', objectFit: 'contain' }} />
        </FlexRow>
        <FlexRow style={{ justifyContent: "space-between" }}>
          <FlexColumn style={{ gap: "0.5rem" }}>
            <Ptag fontWeight="500" fontSize="14px" color={colors.baseBlue}>
              Amount Allotted
            </Ptag>
            <Ptag fontWeight="800" fontSize="20px">
              {details?.amount_alloted
                ? formatToRupees(details?.amount_alloted.toString())
                : "₹0"}
            </Ptag>
          </FlexColumn>
          <FlexColumn style={{ gap: "0.5rem" }}>
            <Ptag fontWeight="500" fontSize="14px" color={colors.baseBlue}>
              Amount Utilized
            </Ptag>
            <Ptag fontWeight="800" fontSize="20px">
              {details?.amount_utilised
                ? formatToRupees(details?.amount_utilised.toString())
                : "₹0"}
            </Ptag>
          </FlexColumn>
        </FlexRow>
        <FlexColumn style={{ gap: "0.5rem" }}>
          <Ptag fontWeight="500" fontSize="14px" color={colors.baseBlue}>
            Remaining Balance
          </Ptag>
          <Ptag fontWeight="800" fontSize="20px">
            {details?.remaining_balance
              ? formatToRupees(details?.remaining_balance.toString())
              : "₹0"}
          </Ptag>
        </FlexColumn>
        <Divider sx={{}} />
        <LargeButton
          onClick={() => redirectToUpdatePage()}
          label={"Update Balance"}
          style={{ marginTop: "0px" }}
        />
      </Box>
    </>
  );
}

export default BufferCard;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  height: 30rem;
  width: 40rem;
  border: 1px solid ${colors.baseBlue};
  border-radius: 10px;
  padding: 2rem;
  gap: 2rem;
  background-color: #e5f7ff4d;
`;

export const FlexRow = styled.div`
  display: flex;
`;
